import { Panel } from "../../../../components/panels/Panel";
import { ErgonomicsGraph } from "../ErgonomicsGraph";
import { useErgonomicsContext } from "../../../../contexts/ErgonomicsContext";
import { ErgonomicsNeedZoom } from "../ErgonomicsNeedZoom";

export const ErgonomicsCardMainDetailsGraphs = () => {
  const { viewModeLabel, zoomDateRange } = useErgonomicsContext();

  return (
    <Panel title="DONNEES OBSERVEES - DETAILS DES SCORES TABLE A / TABLE B / TABLE C" subTitle={viewModeLabel} height="full">
      {
        zoomDateRange === null ? <ErgonomicsNeedZoom/> :
        <>
          <ErgonomicsGraph stepNumber={13} maxValue={12} title="Table C" mode="zoom" />
          <ErgonomicsGraph stepNumber={4} maxValue={9} title="Table A" mode="zoom" />
          <ErgonomicsGraph stepNumber={10} maxValue={9} title="Table B" mode="zoom" />
        </>
      }
    </Panel>
  );
};